import clsx from 'clsx';
import { MouseEvent } from 'react';

import { CrossIcon } from 'src/components/icons';
import { useIsMiddleSchoolView } from 'src/hooks/use-is-middle-school-view';

import './close-button.scss';

interface Props {
  onClose?: (e: MouseEvent) => void;
  classNames?: string;
  isDisabled?: boolean;
  crossIconWidth?: number;
  crossIconHeight?: number;
  testId?: string;
}

const CloseButton = ({
  onClose,
  classNames,
  isDisabled,
  crossIconWidth,
  crossIconHeight,
  testId,
}: Props) => {
  const isMiddleSchoolView = useIsMiddleSchoolView();

  return (
    <button
      onClick={onClose}
      className={clsx(classNames, 'close-button')}
      disabled={isDisabled}
      aria-disabled={isDisabled}
      aria-label="Close"
      data-testid={testId}
    >
      {!isMiddleSchoolView ? (
        <CrossIcon
          className="close-button__icon"
          width={crossIconWidth}
          height={crossIconHeight}
        />
      ) : (
        <i className="ms-close-icon icon-v2-close" />
      )}
    </button>
  );
};

export default CloseButton;
